import debounce from 'debounce';
import select from 'dom-select';

export const Details = (el) => {
  const ui = {
    el,
    body: select('body', document),
    summary: select('.summary', el),
    content: select('.details__content', el),
    iframe: select('iframe', el),
    video: select('.video', el),
  };

  const setHash = (e) => {
    let hash = '#' + e;

    // https://lea.verou.me/blog/2011/05/change-url-hash-without-page-jump/
    if (window.history.pushState) {
      window.history.pushState(null, null, hash);
    }
    else {
      window.location.hash = hash;
    }
  };

  const handleToggle = (event) => {
    event.preventDefault();
    // stop any videos from playing
    if (event.newState === 'closed') {
      if (ui.iframe) {
        let iframeSrc = ui.iframe.src;
        ui.iframe.src = iframeSrc;
      } else if (ui.video) {
        ui.video.pause();
      }
    }
  };

  const addEvents = () => {
    ui.el.addEventListener('toggle', (event) => {
      handleToggle(event);
    });

    ui.summary.addEventListener('click', (e) => {
      setHash(ui.el.id);
    });

    ui.content.addEventListener('click', () => {
      ui.summary.focus();
    });
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default Details;
